import React from "react";
import { features } from "../../data/mock";
import { Check } from "lucide-react";

const Features = () => {
  return (
    <section id="features" className="py-24 px-4 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-wider uppercase">
            Everything Included
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-4">
            Full Feature List
          </h2>
          <p className="text-slate-400">Every tool you need to dominate your local market</p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feature, index) => {
            const [title, description] = feature.split(" - ");
            return (
              <div
                key={index}
                className="bg-slate-800/30 border border-slate-800 rounded-xl p-5 hover:border-emerald-500/30 transition-all group"
              >
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-emerald-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-emerald-500/30 transition-colors">
                    <Check className="w-4 h-4 text-emerald-400" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-white text-sm mb-1">
                      {title}
                    </h4>
                    <p className="text-slate-500 text-xs leading-relaxed">
                      {description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
